const dateStartFormat = (momentDateStart) =>
    momentDateStart.format('YYYY-MM-DD');

export { dateStartFormat };
